<div class="backdrop fade" *ngIf="isOpen">
	<div class="dialog-container" (click)="close($event, true)" [@fadeInOut] (@fadeInOut.done)="fadeInOutDone($event)">
		<ng-content></ng-content>
	</div>
</div>
